var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchieve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.75H2.5C2.16848 3.75 1.85054 3.8817 1.61612 4.11612C1.3817 4.35054 1.25 4.66848 1.25 5V6.875C1.25 7.20652 1.3817 7.52446 1.61612 7.75888C1.85054 7.9933 2.16848 8.125 2.5 8.125V15C2.5 15.3315 2.6317 15.6495 2.86612 15.8839C3.10054 16.1183 3.41848 16.25 3.75 16.25H16.25C16.5815 16.25 16.8995 16.1183 17.1339 15.8839C17.3683 15.6495 17.5 15.3315 17.5 15V8.125C17.8315 8.125 18.1495 7.9933 18.3839 7.75888C18.6183 7.52446 18.75 7.20652 18.75 6.875V5C18.75 4.66848 18.6183 4.35054 18.3839 4.11612C18.1495 3.8817 17.8315 3.75 17.5 3.75ZM16.25 15H3.75V8.125H16.25V15ZM17.5 6.875H2.5V5H17.5V6.875ZM7.5 10.625C7.5 10.4592 7.56585 10.3003 7.68306 10.1831C7.80027 10.0658 7.95924 10 8.125 10H11.875C12.0408 10 12.1997 10.0658 12.3169 10.1831C12.4342 10.3003 12.5 10.4592 12.5 10.625C12.5 10.7908 12.4342 10.9497 12.3169 11.0669C12.1997 11.1842 12.0408 11.25 11.875 11.25H8.125C7.95924 11.25 7.80027 11.1842 7.68306 11.0669C7.56585 10.9497 7.5 10.7908 7.5 10.625Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchieve);
export default __webpack_public_path__ + "static/media/Archieve.a0a640e568ad3a88125a56c102a589ad.svg";
export { ForwardRef as ReactComponent };